import { getLanguage, type I18nLanguage } from '@/i18n';
import { de, el, enUS as en, et, fr, it, pt } from 'date-fns/locale';
import { capitalize } from 'lodash';

// react-aria formats dates (segment order, month names, separators) by
// BCP 47 locale. Every supported language is day-first (see
// localeConfigurations), so 'en' maps to en-GB rather than the month-first
// en-US a browser default could pick.
const bcp47Locales: Record<I18nLanguage, string> = {
  en: 'en-GB',
  it: 'it-IT',
  de: 'de-DE',
  pt: 'pt-PT',
  fr: 'fr-FR',
  el: 'el-GR',
  et: 'et-EE',
};

export const getBcp47Locale = () =>
  bcp47Locales[getLanguage() as I18nLanguage] ?? 'en-GB';

export const locales = {
  en,
  it: {
    ...it,
    localize: {
      ...it.localize,
      // @ts-expect-error args typed as any[]
      day: (...args) => capitalize(it.localize.day(...args)),
      // @ts-expect-error args typed as any[]
      month: (...args) => capitalize(it.localize.month(...args)),
    },
  },
  de,
  pt: {
    ...pt,
    localize: {
      ...pt.localize,
      // @ts-expect-error args typed as any[]
      day: (...args) => capitalize(pt.localize.day(...args)),
      // @ts-expect-error args typed as any[]
      month: (...args) => capitalize(pt.localize.month(...args)),
    },
  },
  fr,
  el: {
    ...el,
    localize: {
      ...el.localize,
      // @ts-expect-error args typed as any[]
      day: (...args) => capitalize(el.localize.day(...args)),
      // @ts-expect-error args typed as any[]
      month: (...args) => capitalize(el.localize.month(...args)),
    },
  },
  et: {
    ...et,
    localize: {
      ...et.localize,
      // @ts-expect-error args typed as any[]
      day: (...args) => capitalize(et.localize.day(...args)),
      // @ts-expect-error args typed as any[]
      month: (...args) => capitalize(et.localize.month(...args)),
    },
  },
} as const;

export type Locale = (typeof locales)[keyof typeof locales];
